import { api } from "./api";

export const glossaryDropDownApi = (params) => {
    return api.get(`/translation/glossary-list`, { params: params });
};

export const documentsDropDownApi = (params) => {
    return api.get(`/translation/documents-list`, { params: params });
};

export const getSignedUrlApi = (params) => {
    return api.post(`/translation/signed-url`, JSON.stringify(params));
};

export const translateDocApi = (params) => {
    return api.post(`/translation/translate-doc`, JSON.stringify(params));
};

export const translateDocMorePagesApi = (params) => {
    return api.post(`/translation/translate-document`, JSON.stringify(params));
};

export const translateHtmlFileApi = (params) => {
    return api.post(`/translation/translate-html`, JSON.stringify(params));
};

export const viewDocApi = (params) => {
    return api.post(`/translation/view-document`, JSON.stringify(params));
};

export const recentTranslationsListApi = (params) => {
    return api.get(`/translation/jobs/list`, { params });
};

export const viewTranslationJobApi = (params) => {
    return api.get(`/translation/jobs/view`, { params });
};

export const publishDocApi = (params) => {
    return api.post(`/translation/jobs/publish`, JSON.stringify(params));
};

export const sendPostEditingApi = (params) => {
    return api.post(`/translation/jobs/send-post-editing`, JSON.stringify(params));
};

export const listPostEditingApi = (params) => {
    return api.get(`/translation/post-editing/list`, { params });
};

export const postEditWordApi = (params) => {
    return api.post(`/translation/post-editing/post-edit-word`, JSON.stringify(params));
};

export const completeReviewApi = (params) => {
    return api.post(`/translation/post-editing/review`, JSON.stringify(params));
};

export const getWordTextBlocksApi = (params) => {
    return api.get(`/translation/post-editing/get-doc-blocks`, { params });
};

export const getPptxTextBlocksApi = (params) => {
    return api.get(`/translation/post-editing/pptx-text-blocks`, { params });
};

export const getPdfTextBlocksApi = (params) => {
    return api.get(`/translation/post-editing/pdf-text-blocks`, { params });
};

export const getHtmlTextBlocksApi = (params) => {
    return api.get(`/translation/post-editing/html-text-blocks`, { params });
};

export const updateWordFileApi = (params) => {
    return api.post(`/translation/post-editing/update-word-file`, JSON.stringify(params));
};

export const updatePptxFileApi = (params) => {
    return api.post(`/translation/post-editing/update-pptx-file`, JSON.stringify(params));
};

export const updatePdfFileApi = (params) => {
    return api.post(`/translation/post-editing/update-pdf-file`, JSON.stringify(params));
};

export const updateHtmlFileApi = (params) => {
    return api.post(`/translation/post-editing/update-html-file`, JSON.stringify(params));
};

export const sendToModelApi = (params) => {
    return api.post(`/translation/post-editing/send-to-model`, JSON.stringify(params));
};

export const draftedDetailsApi = (params) => {
    return api.get(`/translation/post-editing/draft-details`, { params });
};

export const updatePostEditJobApi = (params) => {
    return api.post(`/translation/post-editing/update-job`, JSON.stringify(params));
};

export const translateFileApi = (params) => {
    return api.post(`/translation/translate-file`, JSON.stringify(params));
};
